export default {"src":"/_next/static/media/font_regular.6ca47c01.svg","height":24,"width":24};